<footer>
  <section class="upper">
    <div class="footer-left wow animate__fadeInLeft">
      <img src="../../theme/images/logo.svg" routerLink="/" title="same" alt="KudosHub Technologies" />
      <p class="justify-text">
        KudosHub delivers AI-powered Email Validation and Scoring solutions with 99% accuracy, helping businesses
        improve deliverability, data quality, and trust worldwide.
      </p>
      <p class="justify-text pb-0">
        Our reliable APIs and automation tools enable teams to integrate, scale, and protect sender reputation
        effortlessly.
      </p>
    </div>
    <div class="footer-right wow animate__fadeInRight">
      <h2 class="d-inline-block">Join our monthly newsletters</h2>
      <div class="footer-social-icons wow animate__fadeInLeft">
        <ul class="social-icons">
          <li>
            <a href="https://www.facebook.com/KudosHub/" title="facebook link" target="_blank" class="social-icon">
              <i class="fab fa-facebook-f"></i></a>
          </li>
          <li>
            <a href="https://twitter.com/KudosHub" title="twitter link" target="_blank" class="social-icon">
              <i class="fab fa-twitter"></i></a>
          </li>
          <li>
            <a href="https://www.youtube.com/channel/UCN_L5eAxhiRYcjMd60y4gwg" title="youtube link" target="_blank"
              class="social-icon">
              <i class="fab fa-youtube"></i></a>
          </li>
          <li>
            <a href="https://www.linkedin.com/company/kudoshub" title="linkedin link" target="_blank"
              class="social-icon">
              <i class="fab fa-linkedin-in"></i></a>
          </li>
        </ul>
      </div>
      <form [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">
        <input formControlName="email" aria-label="Email address for newsletter signup" (focus)="emailInput()"
          class="formcontrolname1" name="email" placeholder="Enter your email address" autocomplete="off" />

        @if (loader) {
        <img src="../../theme/table-loader.svg" alt="table-loader" style="width: 95px; height: 45px" />
        }
        @if (!loader) {
        <button class="subscribe subscribe1">SUBSCRIBE</button>
        }
        @if (
        subscribeForm.controls.email.touched &&
        subscribeForm.controls.email.hasError('pattern')
        ) {
        <span class="error-detail">
          Syntax Error! Please enter a valid email address
        </span>
        }
      </form>
      <div class="clearfix"></div>
      <div class="footer-items">
        <h3>Navigation Links</h3>
        <ul>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/who-we-are" title="who we are">Who we are</a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/what-we-do" title="what we do">What we do</a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/why-kudoshub" title="why kudoshub">Why KudosHub</a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/career-with-us" title="career with us">Career with us
            </a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/get-in-touch" title="get in touch">Get in Touch</a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/docs" title="docs" target="_blank">Documentation</a>
          </li>
        </ul>
      </div>
      <div class="footer-items">
        <h3>Services we offer</h3>
        <ul>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/email-marketing" title="email-marketing">Email
              Marketing</a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/email-validation" title="email-validation">Email
              Validation</a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a href="/integrations" title="integrations"
              class="comingSoon">Integrations
              <!-- <sup class="soon">Coming Soon</sup> -->
            </a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/web-development" title="web-development">Web Design &
              Development</a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/mobile-app-development"
              title="mobile-app-development">Mobile App Development</a>
          </li>
          <li>
            <i class="fas fa-caret-right cpad"></i><a routerLink="/our-policies" title="our-policies">Our Policies</a>
          </li>
        </ul>
      </div>
      <div class="footer-items2">
        <h3>Locate Us</h3>
        <i class="fas fa-home cpad2"></i>
        <p>
          59-2, Inder Vihar, Kalidas Road, Dehradun, Uttarakhand, India
        </p>
        <i class="fas fa-mobile-alt cpad2"></i>
        <p>
          +91 99971 00097
          <br />
          0135-2651300
        </p>
        <i class="fas fa-envelope cpad2 mb-1"></i>
        <p><a href="mailto:hello@kudoshub.com" title="mail">hello&#64;kudoshub.com</a></p>
      </div>
    </div>
  </section>
  <section class="bottom">
    <div class="copyright wow animate__fadeInRight">
      &#169; {{year}} KudosHub.Com, All rights reserved
    </div>
  </section>
</footer>